// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#img-ly-scene-editor[data-v-3d8ca72c]{display:none;max-width:1600px}h5.scene-title[data-v-3d8ca72c]{display:inline-block}", ""]);
// Exports
module.exports = exports;
